import $ from 'jquery'

function blogLoadMore () {
  const $loadmore = $('.blog-archive-loadmore');
  $loadmore.each(function(){
    let loadmore_cat = $(this).data('category');
    let $loadmore_btn = $(this).find('.js-loadmore');
    let $loadmore_list = $(this).find('.row');
    let page = 2; // Since you already display the first page
    $loadmore_btn.click(function() {
        var data = {
            'action': 'more_post_ajax',
            'nonce': ajaxObject.ajax_nonce,
            'page': page,
            'cat': loadmore_cat,
        };
        $.post(ajaxObject.ajax_url, data, function(response) {
            if(response != '') {
                $loadmore_list.append(response);
                page++;
            } else {
                $loadmore_btn.hide();
            }
        });
    });
  });

}

export { blogLoadMore }
